import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import LanguageProvider from "./context/LanguageContext";
import {createTheme, ThemeProvider} from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById('root'));

const themeSettings = {
    palette: {
        mode: "light",
        primary: {
            light: "#e0e0e0",
            main: "#464646",
            dark: "#000000",
            contrastText: "#fff"
        },
        secondary: {
            light: "#a1f2f8",
            main: "#00A4B2",
            dark: "#076b74",
            contrastText: "#fff"
        },
        primaryReverse: {
            light: "#000000",
            main: "#e0e0e0",
            dark: "#e0e0e0",
            contrastText: "#33373B"
        },
        error: {
            main: "#ED0000",
            contrastText: "#fff"
        },
        warning: {
            main: "#FFD84E",
            contrastText: "#fff"
        },
        success: {
            main: "#9EFF00",
            contrastText: "#fff"
        },
        mainButton: {
            main: "#00A4B2",
            contrastText: "#fff"
        },
        mainButtonReverse: {
            main: "#fff",
            contrastText: "#00A4B2"
        },
        secondaryButton: {
            main: "#fff",
            contrastText: "#000"
        },
        slider: {
            main: "#5247AF",
            contrastText: "#fff"
        },
        userBar: {
            background: "#ebebeb"
        }
    },
    typography: {
        fontFamily: '"Inter", sans-serif',
        h1: {fontFamily: '"Mont", sans-serif'},
        h2: {fontFamily: '"Mont", sans-serif'},
        h3: {fontFamily: '"Mont", sans-serif'},
        h4: {fontFamily: '"Mont", sans-serif'},
        h5: {fontFamily: '"Mont", sans-serif'},
        h6: {fontFamily: '"Mont", sans-serif'},
    },
    components: {
        MuiPaper: {
            defaultProps: {
                elevation: 0,
            },
            styleOverrides: {
                rounded: {
                    borderRadius: "16px",
                    boxShadow: '0px 2px 8px 0px rgba(0,0,0,0.16)',
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: '50px', // Legyen a gomb lekerekített
                    '&.MuiButton-sizeLarge': { // Csak akkor legyen 19px, ha primary a szín
                        fontSize: '19px',
                        fontWeight: 'bold',
                    },
                },
            }
        },
    }
};

const theme = createTheme(themeSettings);

root.render(
    <React.StrictMode>
        <LanguageProvider>
            <ThemeProvider theme={theme}>
                <App/>
            </ThemeProvider>
        </LanguageProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
